import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-registration-complete',
  templateUrl: './registration-complete.component.html',
  styleUrl: './registration-complete.component.scss'
})
export class RegistrationCompleteComponent {
  constructor(public translateService: TranslateService, private router: Router) {}
  onLogin() {
    this.router.navigate(['/login']);
  }

  getYear() {
    return new Date().getFullYear();
  }
}
